<soft-query-bar-item [icon]="'fa-regular fa-calendar-day'"
                     [title]="title()"
                     [value]="(value() | format:'DATE.DEFAULT')"
                     (click)="onClick()">
</soft-query-bar-item>
